import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { DELIVERY_METHODS_STEP, PAYMENT_STEP } from '../SteppedCheckout/constants';

import styles from './Step.module.scss';
import messages from './messages';
import useTealium from '../../../hooks/useTealium/useTealium';
import { StepProps } from './types';

const Step = ({
  title,
  isCompleted = false,
  isCurrent,
  isEditing,
  stepKey,
  onClickEdit,
  children,
  isDraftCart = false,
  storeTypeId = null,
}: StepProps) => {
  const { formatMessage } = useIntl();
  useTealium({ isCompleted, isEditing, isCurrent, title });
  const hideEditLink =
    stepKey === DELIVERY_METHODS_STEP && isDraftCart && storeTypeId;
  const isPaymentMethodStep = stepKey === PAYMENT_STEP;

  return (
    <div className={classnames(styles['step-container'], {
      [styles['payment-method-step']]: isPaymentMethodStep,
    })}>
      <div className={styles['title-container']}>
        <h2
          className={classnames({
            [styles.title]: true,
            [styles['title-disabled']]: !isCompleted && !isCurrent,
          })}
        >
          {title}
        </h2>
        {isCompleted && !isEditing && !hideEditLink && (
          <span
            className={styles['edit-button']}
            onClick={() => onClickEdit({ step: stepKey })}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onClickEdit({ step: stepKey });
              }
            }}
          >
            {formatMessage(messages.edit)}
          </span>
        )}
      </div>
      {children}
    </div>
  );
};

export default Step;
